import './global.scss';

export default function Toma(): null {
  return null;
}
